import { 
  h, defineComponent, defineAsyncComponent,
} from 'vue';
import { vueCreateAppInit } from '@/utils/js/initVariable';

import { getAuthLink } from '@/api/UserWorkspaceDataApi';
import { showPreAnnotationDragPopup } from '@/views/Home/component/ManagePanel/components/SelectedTreeTable/utils/usePolyInfoPanel';
import shootIconUrl from '@/assets/icon/marker/film.png';
const iconSize = 24,
      iconSizes = [ iconSize, iconSize ],
      iconAnchor = iconSizes.map(e=> e / 2 );

const getVideoFile = (name)=>{
  return new Promise((resolve, reject)=>{
    getAuthLink(name).then(res=>{
      if(res.data.code == 1004){
        resolve(res.data.data);
      }else{
        resolve();
      }
    }).catch(err=>{
      resolve();
      console.log(err);
    });
  })
}

const shootAppInit = (url)=>{
  return vueCreateAppInit(
    defineComponent({
      setup(){
        return ()=> h('video', {
          controls: true,
          style: { width: '300px', height: 'auto' },
          src: url,
          autoplay: false,
          loop: true,
          // onClick: click=>{
          //   const video = click.target;
          //   video.requestFullscreen?.();
          // }
        })
      }
    })
  );
}
// 视频文件 layer
export const shootLayerUse = (target, shootName)=>{
  return new Promise(async (resolve, reject)=>{
    const marker = L.marker(target, {
      icon: L.icon({
        iconUrl: shootIconUrl,
        iconSize: iconSizes,
        iconAnchor: iconAnchor,
      })
    });
    resolve(marker);
    const data = await getVideoFile(shootName);
    if(data){
      const popupContent = document.createElement('div');
            shootAppInit(data).mount(popupContent);
            
      marker.bindPopup(popupContent, {
        closeButton: false,
        autoClose: false,
        offset: [ 0, 0 ],
        direction: 'top',
      })
    }
  })
}

// 影像 layer
import { getAuthUrlById } from '@/api/RegionalShoot';
import axios from 'axios';

export const imageLayerUse = (target)=>{
  return new Promise(async (resolve, reject)=>{
    let tifLayer = null;
    try {
      const res = await getAuthUrlById(target['id']);
      const fileURL = res.data.data;
      if(!fileURL){
        resolve(tifLayer);
        return;
      };
      const fileRes = await axios.get(fileURL, {
        responseType: 'arraybuffer',
      })
      if(fileRes.status == 200 && fileRes.data){
        parseGeoraster(fileRes.data).then(georaster=>{
          tifLayer = new GeoRasterLayer({
            georaster: georaster,
            resolution: 256,
            opacity: 1,
            className: 'leaflet-tif-layer'
          })
          // 其它内容处理
          resolve(tifLayer);
        }).catch(err=>{
          resolve(tifLayer);
          console.log(err);
        });
      }else{
        resolve(tifLayer);
      }
    } catch (error) {
      resolve(null);
    }
  })
}
// geojson layer
export const geojsonUse = (json)=>{
  return new Promise(async (resolve, reject)=>{
    resolve(
      L.geoJSON(json)
    );
  })
}
// region layer
export const regionGeoUse = (target)=>{
  return new Promise(async (resolve, reject)=>{
    const geojson = L.geoJSON(
      JSON.parse(target['regionGeom'])
    );
      const infoTarget = Object.assign({
        geom: target['regionGeom'],
        annotationName: target['regionName'],
        eventList: target['eventList'],
        exposureCountList: target['exposureDateAggList'],
        regionFeatureList: target['tags'],
        regionIntention: target['regionDesc'],
        shootingLocationList: target['shootingLocationList'],
        ifContinuousStatistics: target['ifContinuousStatistics'],
        ifContinuousTracking: target['ifContinuousTracking'],
        taskIds: target['taskIds'],
      });

      geojson.on('click', (e) => {
        L.DomEvent.stopPropagation(e.originalEvent);
        const map = e.target._map || window.map; // 尝试从事件对象或全局获取 map，或引入 store
        showPreAnnotationDragPopup(map, infoTarget, e.latlng, geojson);
      });

    resolve(geojson);
  })
}
// exposure layer
export const exposureLayerUse = (data)=>{
  return new Promise(async (resolve, reject)=>{
    const layerGroup = L.featureGroup();
    (data || []).forEach(item => {
      const text = `
        ${ item['scanSatelliteType'] } ${ item['scanProductCloudPercent'] }<br/>
        ${ item['scanProductTime'] }
      `;
      L.geoJSON(
        JSON.parse(item['scanSatellitePolygon']),
        {
          onEachFeature: (feature, layer)=>{
            layer.setStyle({
              color: 'rgb(242, 186, 44)',
            })
          }
        }
      ).bindTooltip(text, {
        // offset: [0, 40],
        sticky: true,
        className: "leaflet-tooltip-message",
        direction: 'top',
        // maxWidth: 300,
        // maxHeight: 20,
        // permanent: true,
      }).addTo(layerGroup);
    });
    resolve(layerGroup);
  })
}
